import {Injectable} from '@angular/core';
import {OrdersTradesTableRequest} from '../../model/clearing/orders-trades-table-request';
import {CookieNames} from '../../shared/cookie/cookie-names';
import {CcStorageService} from "../common/cc-storage.service";
import {AppConfigService} from "../app-config.service";
import {CtrlAMode} from "../../crystal-clear/clearing/table/trade/trade-table.component";

@Injectable({
  providedIn: 'root'
})
export class ClearingCookieService {

  constructor(private storageService: CcStorageService, private appConfigService: AppConfigService) {
  }

  storeFilterSortState(userViewId: number, origin: string, request: OrdersTradesTableRequest | any): void {
    if (!request?.originEvent) return;

    const copyRequest: OrdersTradesTableRequest = {
      ...request,
      filters: [...request?.filters],
      filters2: [],
      filters3: [...request?.filters3],
      first: 0,
      rows: 100,
      syncMetadata: undefined,
      originEvent: undefined,
      visibleFields: undefined
    };

    const key = CookieNames.CLEARING_FILTERS_SORT_SELECTED_ + userViewId + '_' + origin;
    this.storageService.set(key, JSON.stringify(copyRequest));
  }

  loadFilterSortState(userViewId: number, origin: string): OrdersTradesTableRequest | null {
    const key = CookieNames.CLEARING_FILTERS_SORT_SELECTED_ + userViewId + '_' + origin;
    if (this.storageService.check(key)) {
      return JSON.parse(this.storageService.get(key));
    }
    return null;
  }

  loadVisibleColumns(userViewId: number, origin: string): string[] {
    const key = CookieNames.CLEARING_VISIBLE_COLUMNS_ + userViewId + '_' + origin;
    if (this.storageService.check(key)) {
      return JSON.parse(this.storageService.get(key));
    }
    return [];
  }

  storeVisibleColumns(userViewId: number, origin: string, columns: string[]): void {
    const key = CookieNames.CLEARING_VISIBLE_COLUMNS_ + userViewId + '_' + origin;
    this.storageService.set(key, JSON.stringify(columns));
  }

  clearVisibleColumns(userViewId: number, origin: string): void {
    const key = CookieNames.CLEARING_VISIBLE_COLUMNS_ + userViewId + '_' + origin;
    this.storageService.delete(key);
  }

  isMaximized(userViewId: number, origin: string): boolean {
    const key = CookieNames.CLEARING_TABLE_MAXIMIZED_ + userViewId + '_' + origin;
    return this.storageService.check(key) && this.storageService.get(key) === 'true';
  }

  storeMaximizedState(userViewId: number, origin: string, state: boolean): void {
    const key = CookieNames.CLEARING_TABLE_MAXIMIZED_ + userViewId + '_' + origin;
    this.storageService.set(key, JSON.stringify(state));
  }

  loadSelectedFilter(userViewId: number): string[] {
    let filterWithValue: string[] = [...this.appConfigService.tradeAggregationColumns
      .filter(value => value.defaultIgnore && value.filterable)
      .map(value => value.field)];
    const key = CookieNames.TRADE_SELECTION_FILTER_SELECTED_ + userViewId;
    if (this.storageService.check(key)) {
      filterWithValue = JSON.parse(this.storageService.get(key));
    }
    return filterWithValue;
  }

  storeSelectedFilter(userViewId: number, values: string[]): void {
    const key = CookieNames.TRADE_SELECTION_FILTER_SELECTED_ + userViewId;
    this.storageService.set(key, JSON.stringify(values));
  }

  isSelectionInfo() {
    if (this.storageService.check(CookieNames.TRADE_SELECTION_INFO)) {
      if (this.storageService.get(CookieNames.TRADE_SELECTION_INFO) === 'false') {
        return false;
      }
    }
    return true;
  }

  isSelectionInfoLock() {
    if (this.storageService.check(CookieNames.TRADE_SELECTION_INFO_LOCK)) {
      if (this.storageService.get(CookieNames.TRADE_SELECTION_INFO_LOCK) === 'true') {
        return true;
      }
    }
    return false;
  }

  storeSelectionInfo(isSelectionInfoEnabled: boolean) {
    this.storageService.set(CookieNames.TRADE_SELECTION_INFO, JSON.stringify(isSelectionInfoEnabled));
  }

  storeSelectionInfoLock(isSelectionInfoEnabledLock: boolean) {
    this.storageService.set(CookieNames.TRADE_SELECTION_INFO_LOCK, JSON.stringify(isSelectionInfoEnabledLock));
  }

  loadTradeCtrlAMode(): CtrlAMode {
    if (this.storageService.check(CookieNames.TRADE_CTRL_A_MODE)) {
      return JSON.parse(this.storageService.get(CookieNames.TRADE_CTRL_A_MODE));
    }
    return 'ALL_OPTIM';
  }

  storeTradeCtrlAMode(ctrlAMode: CtrlAMode) {
    this.storageService.set(CookieNames.TRADE_CTRL_A_MODE, JSON.stringify(ctrlAMode));
  }
}
